export const TABLE_LIMIT_SMALL: number = 10;
export const TABLE_LIMIT_MEDIUM: number = 25;
export const TABLE_LIMIT_DEFAULT: number = 50;
export const TABLE_LIMIT_LARGE: number = 100;
